import React, { useState } from "react";

import { toEvalCase, useEvalSuite } from "@/shared/api/evals";
import PublishGate from "@/shared/components/PublishGate";
import usePublish from "./usePublish";

import type { Agent } from "@/shared/types";

/* Publish the way the agent asks for it, wherever Publish is offered (its Settings, the
   chat's unpublished note). With the agent's "Run evals first" switch on (in General) and
   cases to run, `start` runs them on the draft first (`PublishGate`) and publishes from
   there; otherwise it publishes straight away. `dialog` is that gate: render it beside
   the button. */
export default function usePublishFlow(agent: Agent) {
  const { publish, publishing, changed } = usePublish(agent);
  const [gate, setGate] = useState(false);
  const suite = useEvalSuite(agent.id).data;
  const cases = (suite?.cases ?? []).map(toEvalCase);
  const baseRunId = suite?.baseline_run_id ?? suite?.runs.find((r) => r.status === "done")?.id ?? null;
  const gated = (agent.evalsBeforePublish ?? true) && cases.length > 0;

  const dialog = (
    <PublishGate
      open={gate}
      onOpenChange={setGate}
      agent={agent}
      evals={{ cases, checks: [], runs: [], baselineRunId: suite?.baseline_run_id ?? null }}
      baseRunId={baseRunId}
      // the edits are in the draft already: the check runs on it as it stands
      prepare={async () => true}
      onConfirm={() => { setGate(false); void publish(); }}
    />
  );

  return { start: () => (gated ? setGate(true) : void publish()), publishing, changed, gated, dialog };
}
